import { render, staticRenderFns } from "./ProfileBilling.vue?vue&type=template&id=2b5cb983&"
import script from "./ProfileBilling.vue?vue&type=script&lang=js&"
export * from "./ProfileBilling.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBilling.vue?vue&type=style&index=0&id=2b5cb983&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports